import React from 'react'

import { JP, RU, IE, BE, NL } from 'constants/countries'

export default function({ locale, cdn, cdn_global }) {
  return React.useMemo(() => {
    // For Japan we use pics from global folder, except this one — return background
    const rootFolder = locale === JP ? cdn : cdn_global
    const imageName =
      locale === RU || [IE, BE, NL].includes(locale) ? 'cover_v4' : 'cover_v3'

    return `${rootFolder}/common_hiw/return/${imageName}`
  }, [locale, cdn, cdn_global])
}
